module.exports = __webpack_public_path__ + "img/20190603.081d5130.png";